import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'

const StatusBox = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 77px;
  line-height: 77px;
  background-color: rgba(50, 41, 37, 0.8);
  border-radius: 10px 10px 0px 0px;
  text-align: center;
  z-index: 1;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 8px;
    }
  }
`

export default function Status ({status}: {status: number}) {
  return (
    <>
      {
        status === 0
        &&
        <StatusBox>
          <Text color={'#FFCD84'} fontSize={23} fontWeight={700}>
            <img src="/images/nft/icon_pending.svg" alt=""/>
            Pending
          </Text>
        </StatusBox>
      }
      {
        status === -1 
        &&
        <StatusBox>
          <Text color={'#F65B5B'} fontSize={23} fontWeight={700}>
            <img src="/images/nft/icon_reject.svg" alt=""/>
            Rejected
          </Text>
        </StatusBox>
      }
    </>
  )
}